import { FlexGrid, Typography, useThemeProvider } from "@albo-ui/core";
import { Box, Divider, CardContent, Avatar } from "@mui/material";
import { CalendarMonthOutlined } from "@mui/icons-material";
import moment from "moment";
moment.locale("es");

export const CRMCardDeals = ({ item, cardProps }: any) => {
    const { theme } = useThemeProvider();
    const { ctFunnel, getLeadByUuid, revenueSection, tabActive } = cardProps;
    const getDescription = () => {
        let getFunnel = ctFunnel ? ctFunnel.filter((i) => item["funnel"] === i["v"]) : [];
        if (getFunnel.length > 0) {
            return getFunnel[0]["m"][0]["description"];
        } else {
            return item["funnel"] || "Onboarding por iniciar";
        }
    };

    return (
        <CardContent>
            <FlexGrid style={{ display: "grid", paddingBottom: 16 }}>
                <Typography variant="smallTitle" style={{fontSize: 14, lineHeight: "22px", color: theme.colors.paragraph}}>
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a href="#" onClick={getLeadByUuid.bind(this, item["uuid"], tabActive)} title="Ver detalle">
                        {item["general"]["company_name"] || "Sin nombre"}
                    </a>
                </Typography>
                <Typography variant="small" color="darkGray">
                    {(item["ppal_contact"] && item["ppal_contact"]["name"]) || "Por asignar"}
                </Typography>
                {item["general"]["employees_quantity_desc"] && 
                    <Typography variant="small" color="darkGray">
                        {item["general"]["employees_quantity_desc"]}
                    </Typography>
                }
            </FlexGrid>
            {revenueSection(item["revenue"])}
            <Box sx={{py: 1}}>

            <Typography variant="paragraph">
                {getDescription()}
                </Typography>
            </Box>

            <Box sx={{px: 0.8, py: 0.5, mt: 1.1, borderRadius: 2, backgroundColor: "lavender"}} width={"fit-content"}>
                <CalendarMonthOutlined sx={{ fontSize: "small" }} />{" "}
                {moment(new Date(item["cdate"])).format("Do MMM YY")}
            </Box>

            <Divider sx={{ my: 1.5 }} />

            <Box style={{ display: "flex" }}>
                <Avatar alt={item["agent"]["name"]} src={item["agent"]["name"]} sx={{width: "1.5rem", height: "1.5rem", fontSize: 12, mr: 1, bgcolor: "#6CB156"}}/>
                <Typography variant="small" color="darkGray">
                    {item["agent"]["name"]}
                </Typography>
            </Box>
        </CardContent>
    );
};
